import api from ".";
import type { PaginatedList } from "src/types/api";
import type { WalletAccount, WalletTransaction } from "src/types/wallet";

/** Query accepted by the wallet transactions endpoint. */
export interface WalletQuery {
	page?: number;
	limit?: number;
	search?: string;
	startDate?: string | null;
	endDate?: string | null;
}

export const viewWalletAccount = () => api.get<WalletAccount>("/wallet/account");

export const viewWalletBalance = () => api.get<number>("/wallet/balance");

export const viewWalletTransactions = (params?: WalletQuery) => api.get<PaginatedList<WalletTransaction>>("/wallet/transactions", { params });
